// Centralised translations for Tirami.
// Lean dictionary — only UI chrome is translated; brand/product names stay as-is.

export const TRANSLATIONS = {
  en: {
    "nav.story": "Story",
    "nav.bases": "Bases",
    "nav.menu": "Menu",
    "nav.journal": "Journal",
    "nav.contact": "Contact",
    "nav.cart": "Cart",

    "hero.established": "Est. Monterrey — 2026",
    "hero.single_batch": "Single-batch · Daily",
    "hero.tagline": "— Artesanal · Tiramisú",
    "hero.headline_1": "Layers of",
    "hero.headline_2": "Perfection.",
    "hero.description":
      "One dessert. Hand-built from seven ingredients and an obsession that began in a Monterrey kitchen.",
    "hero.cta_order": "View Menu",
    "hero.cta_story": "Our Story",
    "hero.scroll": "Scroll",

    "story.eyebrow": "— 001 / The Obsession",
    "story.headline_1": "One dessert.",
    "story.headline_2": "Studied obsessively.",
    "story.p1":
      "TIRAMI was born in a kitchen in Monterrey, where a single recipe was tested many times. We are specialized in making tiramisu. ",
    "story.p2":
      "The mascarpone is whipped to soft peaks and folded — never beaten. The cocoa is dusted minutes before service. Anything less, and it isn't Tirami.",
    "story.stat_batches": "Test Batches",
    "story.stat_trays": "Trays Daily",
    "story.stat_years": "Years of Folly",
    "story.stat_dessert": "Dessert",

    "bases.eyebrow": "— 002 / The Architecture",
    "bases.headline_1": "Three ingredients.",
    "bases.headline_2": "A thousand possibilities.",
    "bases.savoiardi.label": "01 — The Bone",
    "bases.savoiardi.detail": "Twice-baked Piedmontese ladyfingers. Crisp, porous, structural.",
    "bases.mascarpone.label": "02 — The Soul",
    "bases.mascarpone.detail": "Lombardy cream, separated at dawn. Folded — never whipped — at 14°C.",
    "bases.cocoa.label": "03 — The Crown",
    "bases.cocoa.detail": "Stone-milled Criollo, 22% fat. Dusted minutes before service.",

    "menu.eyebrow": "— 003 / The Variations",
    "menu.headline_1": "Four variations,",
    "menu.headline_2": "each its own ritual.",
    "menu.description":
      "Plated in single-serve trays. Delivered chilled within four hours. Eaten with a small spoon, slowly.",
    "menu.hover_preview": "Hover to preview",
    "menu.add_to_cart": "Add to Cart",
    "menu.per_tray": "per tray",

    "social.eyebrow": "— 004 / On the Gram",
    "social.headline_1": "Loved on",
    "social.headline_2": "the gram.",

    "contact.eyebrow": "— 005 / The Reservation",
    "contact.headline_1": "Tell us how",
    "contact.headline_2": "we can help.",
    "contact.description":
      "Private events, custom trays, press inquiries, or simply a question about technique — we read every word. Replies arrive within twenty-four hours.",
    "contact.first_name": "First Name",
    "contact.last_name": "Last Name",
    "contact.email": "Email",
    "contact.message": "Message",
    "contact.placeholder_first": "Sofia",
    "contact.placeholder_last": "Ricci",
    "contact.placeholder_email": "you@example.com",
    "contact.placeholder_message":
      "Tell us about the occasion, dietary considerations, or the question you can't shake…",
    "contact.send": "Send Message",
    "contact.sending": "Sending…",
    "contact.direct": "Direct",
    "contact.hours": "Mon — Sun · 20:00 — 22:00 GMT",
    "contact.disclaimer":
      "By submitting you agree to receive a reply at the email provided. No marketing. Ever.",
    "contact.toast_success": "Message received. We'll respond within 24 hours.",
    "contact.toast_required": "Please fill in name, email, and message.",
    "contact.toast_error": "Couldn't send your message. Try again shortly.",

    "footer.tagline": "Tiramisú, in single-batch trays, delivered while still humming.",
    "footer.journal_label": "The Journal — weekly",
    "footer.email_placeholder": "your@email.com",
    "footer.subscribe": "Subscribe →",
    "footer.visit": "Visit",
    "footer.hours": "Mon — Sun · 20:00 — 22:00 GMT",
    "footer.reach": "Reach",
    "footer.directions": "Directions",
    "footer.rights": "All rights reserved.",
    "footer.made": "Hand-built in Monterrey",

    "cart.label": "Your Tray",
    "cart.empty_title": "Empty for now.",
    "cart.filled_title": "Selected with care.",
    "cart.empty_message": "No trays yet. Begin with the Classico.",
    "cart.subtotal": "Subtotal",
    "cart.disclaimer":
      "Delivery and tax computed at checkout. Single-batch trays ship same-day before 14:00.",
    "cart.checkout": "Reserve Tray →",
    "cart.per_tray": "per tray",
    "cart.aria_close": "Close cart",
    "cart.aria_desc": "Your cart items and order subtotal",

    "toast.added_suffix": "added to cart",
  },
  es: {
    "nav.story": "Historia",
    "nav.bases": "Bases",
    "nav.menu": "Menú",
    "nav.journal": "Diario",
    "nav.contact": "Contacto",
    "nav.cart": "Carrito",

    "hero.established": "Est. Monterrey — 2026",
    "hero.single_batch": "Lote único · Diario",
    "hero.tagline": "— Artesanal · Tiramisú",
    "hero.headline_1": "Capas de",
    "hero.headline_2": "Perfección.",
    "hero.description":
      "Un postre. Elaborado artesanalmente con siete ingredientes y una obsesión que comenzó en una cocina de Monterrey.",
    "hero.cta_order": "Ver Menú",
    "hero.cta_story": "Nuestra Historia",
    "hero.scroll": "Desliza",

    "story.eyebrow": "— 001 / La Obsesión",
    "story.headline_1": "Un solo postre.",
    "story.headline_2": "Estudiado con obsesión.",
    "story.p1":
      "TIRAMI nació en una cocina de Monterrey, donde se probó una sola receta muchas veces. Nos especializamos en la elaboración de tiramisú.",
    "story.p2":
      "El mascarpone se bate hasta obtener picos suaves y se dobla, nunca se bate. El cacao se espolvorea minutos antes de servir. Si no se sigue este paso, no es TIRAMI.",
    "story.stat_batches": "Lotes de Prueba",
    "story.stat_trays": "Bandejas Diarias",
    "story.stat_years": "Años de Locura",
    "story.stat_dessert": "Postre",

    "bases.eyebrow": "— 002 / La Arquitectura",
    "bases.headline_1": "Tres ingredientes.",
    "bases.headline_2": "Mil posibilidades.",
    "bases.savoiardi.label": "01 — El Hueso",
    "bases.savoiardi.detail":
      "Bizcochos de soletilla piamonteses doblemente horneados. Crujientes, porosos, estructurales.",
    "bases.mascarpone.label": "02 — El Alma",
    "bases.mascarpone.detail":
      "Crema lombarda, separada al amanecer. Incorporada — nunca batida — a 14°C.",
    "bases.cocoa.label": "03 — La Corona",
    "bases.cocoa.detail":
      "Criollo molido en piedra, 22% de grasa. Espolvoreado doce minutos antes del servicio.",

    "menu.eyebrow": "— 003 / Las Variaciones",
    "menu.headline_1": "Cuatro variaciones,",
    "menu.headline_2": "cada una su propio ritual.",
    "menu.description":
      "Servido en bandejas individuales. Entregado refrigerado en cuatro horas. Comido con cucharita, despacio.",
    "menu.hover_preview": "Pasa para ver",
    "menu.add_to_cart": "Añadir al Carrito",
    "menu.per_tray": "por bandeja",

    "social.eyebrow": "— 004 / Tirami en Instagram",
    "social.headline_1": "Nuestra",
    "social.headline_2": "comunidad.",

    "contact.eyebrow": "— 005 / La Reserva",
    "contact.headline_1": "Cuéntanos cómo",
    "contact.headline_2": "podemos ayudar.",
    "contact.description":
      "Eventos privados, bandejas a medida, prensa o simplemente una duda sobre técnica — leemos cada palabra. Respondemos en menos de veinticuatro horas.",
    "contact.first_name": "Nombre",
    "contact.last_name": "Apellido",
    "contact.email": "Correo",
    "contact.message": "Mensaje",
    "contact.placeholder_first": "Sofía",
    "contact.placeholder_last": "Ricci",
    "contact.placeholder_email": "tu@ejemplo.com",
    "contact.placeholder_message":
      "Cuéntanos sobre la ocasión, consideraciones dietéticas o la pregunta que no te deja…",
    "contact.send": "Enviar Mensaje",
    "contact.sending": "Enviando…",
    "contact.direct": "Directo",
    "contact.hours": "Lun — Dom · 20:00 — 22:00 GMT",
    "contact.disclaimer":
      "Al enviar aceptas recibir una respuesta al correo proporcionado. Sin marketing. Nunca.",
    "contact.toast_success": "Mensaje recibido. Responderemos en 24 horas.",
    "contact.toast_required": "Por favor completa nombre, correo y mensaje.",
    "contact.toast_error": "No pudimos enviar tu mensaje. Intenta de nuevo.",

    "footer.tagline":
      "Tiramisú, en bandejas de lote único, entregado mientras aún canta.",
    "footer.journal_label": "El Diario — semanal",
    "footer.email_placeholder": "tu@correo.com",
    "footer.subscribe": "Suscribir →",
    "footer.visit": "Visita",
    "footer.hours": "Lun — Dom · 20:00 — 22:00 GMT",
    "footer.reach": "Contacto",
    "footer.directions": "Cómo llegar",
    "footer.rights": "Todos los derechos reservados.",
    "footer.made": "Hecho a mano en Monterrey",

    "cart.label": "Tu Bandeja",
    "cart.empty_title": "Vacío por ahora.",
    "cart.filled_title": "Elegido con cuidado.",
    "cart.empty_message": "Aún no hay bandejas. Empieza con el Classico.",
    "cart.subtotal": "Subtotal",
    "cart.disclaimer":
      "Envío e impuestos calculados al pagar. Las bandejas de lote único se envían el mismo día antes de las 14:00.",
    "cart.checkout": "Reservar Bandeja →",
    "cart.per_tray": "por bandeja",
    "cart.aria_close": "Cerrar carrito",
    "cart.aria_desc": "Artículos de tu carrito y subtotal del pedido",

    "toast.added_suffix": "añadido al carrito",
  },
};

export const SUPPORTED_LANGS = ["en", "es"];
export const DEFAULT_LANG = "en";
